import React from 'react'
import './About.css'

function About() {
  return (
    <section id="about">
      <h3>Conheça mais</h3>
      <h2>Sobre mim</h2>

      <article>
        <p>
          Olá, sou o Pedro e tenho 23 anos, nascido e criado em Belo Horizonte-MG.
          Sou ex-estudante de Educação Física na UFMG por três semestres no período de 2018 a 2019.
          Atualmente estou em transição de carreira para a área de desenvolvimento web.
        </p>

        <p>
          Iniciei meus estudos na programação em abril de 2022 e me formei desenvolvedor web fullstack pela Trybe Escola de Programação. Durante esse período no curso aprendi e aprimorei diversas habilidades técnicas quanto minhas soft-skills, além de desenvolver na prática diversos projetos tanto de Back-End quanto de Front-End.
        </p>
        <p>
          Atualmente estou na busca pela minha primeira oportunidade no mercado de desenvolvimento web. Sinta-se à vontade para saber um pouco mais sobre minhas hard-skills e meus projetos desenvolvidos abaixo, assim como entrar em contato caso queira.
        </p>
      </article>

    </section>
  )
}

export default About;